import { NavLink, useNavigate, useSearchParams } from "react-router-dom";
import useCartContext from "../hooks/useCartContext";
import useWishlistContext from "../hooks/useWishlistContext";
import useIsInWishlist from "../hooks/useIsInWishlist";
import useApi from "../hooks/useApi";
import Loader from "../Components/Ui/Loader";
import InfoMessage from "../Components/Ui/InfoMessage";
import GiftCard from "../Components/Home/shared/GiftCard";

const Search = () => {
  const navigate = useNavigate();

  const [searchParams, ,] = useSearchParams();

  const q = searchParams.get("q");

  const url =
    q.toLowerCase() === "binance"
      ? "/getBinanceAdvanced"
      : `/getSearchProducts/?searchText=${q}`;

  const { addToCart } = useCartContext();
  const { wishlist, addToWishlist, removeFromWishlist } = useWishlistContext();

  const {
    data: gifts,
    isPending: areGiftsPending,
    error: giftsError,
  } = useApi(url);

  const { data: searchedGifts } = useIsInWishlist(gifts, wishlist);

  return (
    <>
      <section className="sub-banner-link">
        <div className="container">
          <div className="row align-items-center">
            <p className="category_path_title m-0">
              <NavLink to="/" className="homeLink">
                Home{" "}
              </NavLink>
              {`>`} <span>Search</span>
            </p>
          </div>
        </div>
      </section>
      <div className="profile wishlist-item wish-container">
        <div className="container">
          <div className="row justify-content-between item-list">
            <div
              className="account-heading d-flex align-items-center"
              data-aos="fade-up"
              data-aos-delay="2500"
              data-aos-duration="1000"
            >
              <h5 className="mb-5">{q}</h5>
            </div>
            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 wishlist-card">
              <div className="row justify-content-center">
                {areGiftsPending ? (
                  <Loader />
                ) : giftsError ? (
                  <InfoMessage text={giftsError} />
                ) : !searchedGifts?.length ? (
                  <InfoMessage text="No gift cards found. Please try searching some different gift cards." />
                ) : (
                  <div className="row justify-content-center">
                    {searchedGifts?.map((data) => {
                      return (
                        <GiftCard
                          key={data?._id}
                          image={data?.image}
                          inbuildImage={data?.productDetails?.image}
                          title={data?.productDetails?.nameEn || data?.title}
                          category={data?.productDetails?.categoryNameEn}
                          price={data?.priceInSAR?.toFixed(2)}
                          onClick={() =>
                            navigate(
                              `/gifts/${
                                q.toLowerCase() === "binance"
                                  ? "Binance"
                                  : "bitaqaty"
                              }/${data?._id}`
                            )
                          }
                          addToCart={() => {
                            if (q.toLowerCase() === "binance") {
                              addToCart(data?._id, false, "Binance");
                            } else {
                              addToCart(data?._id);
                            }
                          }}
                          addToWishlist={() => {
                            if (q.toLowerCase() === "binance") {
                              addToWishlist(data._id, "Binance");
                            } else {
                              addToWishlist(data._id);
                            }
                          }}
                          removeFromWishlist={() =>
                            removeFromWishlist(data._id)
                          }
                          isInWishlist={data?.isInWishlist}
                          binanceGrid={true}
                        />
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Search;
